import { ChangeDetectorRef, Component, inject, Inject, PLATFORM_ID, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActiveCartFacade, Cart } from '@spartacus/cart/base/root';
import { ProductListService } from 'src/app/services/feature/product-list.service';
import { CheckAvailabilityWebtrekkTrackingService } from './CheckAvailabilityWebtrekkTrackingService';
import { combineLatest, filter, finalize, Observable, take } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-check-availability-dialog',
  templateUrl: './check-availability-dialog.component.html',
  styleUrls: ['./check-availability-dialog.component.scss'],
  standalone: false
})
export class CheckAvailabilityDialogComponent {
  activeCart$: Observable<Cart>;
  selectedOrderType: string = 'EMGY';
  selectedQunatity: any = 1;
  enteredQty: any = '';
  isSubmitted: boolean = false;
  stockRes: any;
  isAvailable: boolean = false;
  isPartialAvailable = false;
  showNextPage: boolean = false;
  showMsg: boolean = false;
  actionName: string;
  isLoading = signal<boolean>(true);
  private platformId = inject(PLATFORM_ID);
  currentB2bUnitSendToWebtrack !: string;
  private destroy$ = new Subject<void>();
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any, public dialogRef: MatDialogRef<CheckAvailabilityDialogComponent>,
    protected activeCartService: ActiveCartFacade, protected productListService: ProductListService, //private pixel: WebtrekkSmartPixelAngular
    private webtrekkTrackingService: CheckAvailabilityWebtrekkTrackingService,
    private cdr: ChangeDetectorRef,) {
  }
  ngOnInit() {
    this.activeCart$ = this.activeCartService.getActive();
    this.activeCart$
      .pipe(
        filter((item: any) => item?.orderType?.entry?.length > 0),
        take(1) // ✅ only once when valid cart comes
      )
      .subscribe((item: any) => {
        const hasEmergency = item.orderType.entry.some(e => e.key === 'EMGY');
        this.currentB2bUnitSendToWebtrack = item?.currentB2BUnit?.uid;
        this.selectedOrderType = hasEmergency
          ? 'EMGY'
          : item.orderType.entry[0]?.key;
        this.cdr.detectChanges();
        this.checkAvailStatus(
          this.selectedOrderType,
          this._data?.productCode,
          this.selectedQunatity
        );
      });
    //this.checkAvailStatus(this.selectedOrderType, this._data?.productCode, this.selectedQunatity)
  }

  checkAvail() {
    this.isSubmitted = true;
    const qty = this.selectedOrderType === 'EMGY' ? this.selectedQunatity : this.enteredQty;
    if (qty) {
      this.checkAvailStatus(this.selectedOrderType, this._data?.productCode, qty, true);
    }

  }

  checkAvailStatus(orderType, productCode, qty, btnClick?) {
    this.isLoading.set(true);
    this.productListService.checkStockAvailability(orderType, productCode, qty).pipe(finalize(() => this.isLoading.set(false))).subscribe((data: any) => {
      this.showMsg = true;
      this.stockRes = data.futureStock;
      this.isAvailable = data.futureStock && data.futureStock.filter(item => item.formattedDate?.toLowerCase() == 'open').length == 0;
      this.isPartialAvailable = data.futureStock && data.futureStock.length > 1 && data.futureStock.filter(item => item.formattedDate?.toLowerCase() == 'open').length > 0;

      this.webtrekk_click(this._data?.page, this.selectedOrderType, this._data?.productCode, qty, this.isAvailable, this.isPartialAvailable, this.stockRes);
      if (btnClick) {
        this.showNextPage = true;
      } else {
        this.showNextPage = false;
      }
      this.cdr.detectChanges(); // ✅ force UI refresh
    })
  }
  back() {
    this.showNextPage = false;
    this.isSubmitted = false;
  }
  resetQty() {
    this.showMsg = false;
    if (this.selectedOrderType !== 'EMGY') {
      this.enteredQty = '';
    } else {
      this.enteredQty = 1
      this.checkAvailStatus(this.selectedOrderType, this._data?.productCode, this.selectedQunatity)
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    const isDigit = event.key >= '0' && event.key <= '9';
    const isControlKey = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(event.key);

    if (!isDigit && !isControlKey) {
      event.preventDefault();
    }
  }
  getCountryCode(): string {
    return isPlatformBrowser(this.platformId) ? window.location.pathname.split('/')[1] : '';
  }
  webtrekk_click(page, orderType, productCode, qty, isAvailable, isPartialAvailable, stockRes) {

    this.webtrekkTrackingService.trackAction(page, orderType, productCode, qty, isAvailable, isPartialAvailable, stockRes, this.getCountryCode(), this.currentB2bUnitSendToWebtrack);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
